import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { useNavigate } from 'react-router-dom'
import { colors, radius, s as t, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const s = {
  card: { ...t.card, padding: '20px', marginBottom: '20px' },
  label: t.label,
  input: t.input
}

const SCENARIO_LABELS = {
  abandoned_cart: { title: 'Terk Edilmiş Sepet', icon: '', desc: 'Sepete ürün ekleyip satın almayan kullanıcılara hatırlatma gönder' },
  inactive_user: { title: 'Pasif Kullanıcı', icon: '', desc: 'Uzun süredir siteye girmeyen kullanıcılara geri dön maili gönder' },
  category_bestseller: { title: 'Kategori Çok Satanları', icon: '', desc: 'En çok gezdiği kategorinin popüler ürünlerini kullanıcıya gönder' },
  purchase_survey: { title: 'Alışveriş Sonrası Anket', icon: '', desc: 'Her gün 11:00\'de, önceki gün siparişi teslim edilen müşterilere değerlendirme anketi gönder' }
}

function SmartMailing() {
  const { selectedBrand, account } = useBrand()
  const navigate = useNavigate()
  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  const [tab, setTab] = useState('config')
  const [config, setConfig] = useState(null)
  const [scenarios, setScenarios] = useState([])
  const [logs, setLogs] = useState([])
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [running, setRunning] = useState({})
  const [msg, setMsg] = useState('')
  const [creatingStore, setCreatingStore] = useState(false)
  const [anketEkrani, setAnketEkrani] = useState(false)

  const [configForm, setConfigForm] = useState({
    mailchimp_api_key: '',
    mailchimp_server: 'us9',
    mailchimp_audience_id: '',
    mailchimp_store_id: '',
    mandrill_api_key: '',
    provider: 'mandrill',
    brevo_api_key: '',
    from_email: '',
    from_name: '',
    is_active: false
  })

  useEffect(() => {
    if (!selectedBrand) return
    fetchAll()
  }, [selectedBrand]) // eslint-disable-line

  async function fetchAll() {
    setLoading(true)
    try {
      const [configRes, scenariosRes, statsRes, logsRes] = await Promise.all([
        axios.get(`${API}/admin/brands/${selectedBrand.id}/mailing-config`, { headers }).catch(() => ({ data: null })),
        axios.get(`${API}/admin/brands/${selectedBrand.id}/mailing-scenarios`, { headers }),
        axios.get(`${API}/admin/brands/${selectedBrand.id}/mailing-stats`, { headers }).catch(() => ({ data: null })),
        axios.get(`${API}/admin/brands/${selectedBrand.id}/mailing-logs?limit=20`, { headers }).catch(() => ({ data: { logs: [] } }))
      ])
      if (configRes.data) {
        setConfig(configRes.data)
        setConfigForm({
          mailchimp_api_key: configRes.data.mailchimp_api_key || '',
          mailchimp_server: configRes.data.mailchimp_server || 'us9',
          mailchimp_audience_id: configRes.data.mailchimp_audience_id || '',
          mailchimp_store_id: configRes.data.mailchimp_store_id || '',
          mandrill_api_key: configRes.data.mandrill_api_key || '',
          provider: configRes.data.provider || 'mandrill',
          brevo_api_key: configRes.data.brevo_api_key || '',
          from_email: configRes.data.from_email || '',
          from_name: configRes.data.from_name || '',
          is_active: configRes.data.is_active || false
        })
      }
      setScenarios(scenariosRes.data || [])
      setStats(statsRes.data)
      setLogs(logsRes.data.logs || [])
    } catch (e) {}
    setLoading(false)
  }

  function showMsg(text) {
    setMsg(text)
    setTimeout(() => setMsg(''), 3000)
  }

  async function saveConfig() {
    setSaving(true)
    try {
      await axios.post(`${API}/admin/brands/${selectedBrand.id}/mailing-config`, configForm, { headers })
      showMsg('Ayarlar kaydedildi ')
      fetchAll()
    } catch (e) {
      showMsg('Hata: ' + (e.response?.data?.error || e.message))
    }
    setSaving(false)
  }

  async function createStore() {
    setCreatingStore(true)
    try {
      const res = await axios.post(`${API}/admin/brands/${selectedBrand.id}/mailing-config/create-store`, {}, { headers })
      showMsg(res.data.message + ' (' + res.data.store_id + ')')
      fetchAll()
    } catch (e) {
      showMsg('Hata: ' + (e.response?.data?.error || e.message))
    }
    setCreatingStore(false)
  }

  async function saveScenario(sc) {
    try {
      await axios.post(`${API}/admin/brands/${selectedBrand.id}/mailing-scenarios`, sc, { headers })
      showMsg('Senaryo kaydedildi ')
      fetchAll()
    } catch (e) {
      showMsg('Hata: ' + (e.response?.data?.error || e.message))
    }
  }

  async function runScenario(scenario) {
    setRunning(r => ({ ...r, [scenario]: true }))
    try {
      const yol = scenario === 'purchase_survey' ? 'survey-run' : `mailing-run/${scenario}`
      const res = await axios.post(`${API}/admin/brands/${selectedBrand.id}/${yol}`, {}, { headers })
      showMsg(`${SCENARIO_LABELS[scenario]?.title} tamamlandı — ${res.data.sent} gönderim${res.data.test_mode ? ' (TEST MODU — yalnız test adresine gitti)' : ''}`)
      fetchAll()
    } catch (e) {
      showMsg('Hata: ' + (e.response?.data?.error || e.message))
    }
    setRunning(r => ({ ...r, [scenario]: false }))
  }

  if (!selectedBrand) return (
    <div style={s.card}>
      <p style={{ ...ui.notice, margin: '0 0 14px' }}>Önce bir marka seçin.</p>
      <button onClick={() => navigate('/brands')} style={t.btnPrimary}>Markalara Git</button>
    </div>
  )

  if (loading) return <p>Yükleniyor...</p>

  if (anketEkrani) return (
    <AnketSonuclari brandId={selectedBrand.id} markaAdi={selectedBrand.name} headers={headers} onBack={() => setAnketEkrani(false)} />
  )

  return (
    <div>
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '8px' }}>
        <h2 style={t.pageTitle}>Smart Mailing — {selectedBrand.name}</h2>
        {msg && <span style={{ fontSize: '13px', color: msg.includes('Hata') ? colors.dangerText : colors.textSecondary }}>{msg}</span>}
      </div>

      {stats && (
        <div className="sx-grid-stat" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '20px' }}>
          {[
            { label: 'Toplam Gönderim', val: stats.total_sent },
            { label: 'Son 7 Gün', val: stats.last_7_days },
            { label: 'Terk Sepet', val: stats.by_scenario?.find(s => s.scenario === 'abandoned_cart')?.total || 0 },
            { label: 'Pasif Kullanıcı', val: stats.by_scenario?.find(s => s.scenario === 'inactive_user')?.total || 0 }
          ].map((item, i) => (
            <div key={i} style={ui.statBox}>
              <div style={ui.statLabel}>{item.label}</div>
              <div style={ui.statValue}>{item.val}</div>
            </div>
          ))}
        </div>
      )}

      <div style={ui.tabBar}>
        {[['config', 'Ayarlar'], ['scenarios', 'Senaryolar'], ['logs', 'Gönderim Logları']].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{ ...ui.tab(tab === key), marginBottom: '-1px' }}>{label}</button>
        ))}
      </div>

      {tab === 'config' && (() => {
        const superAdmin = account?.role === 'super_admin'
        const mailchimpGorunur = superAdmin || configForm.provider === 'mandrill'
        return (
        <div style={s.card}>
          <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
            <h3 style={t.sectionTitle}>Entegrasyon Ayarları</h3>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px' }}>
              <input type="checkbox" checked={configForm.is_active} onChange={e => setConfigForm(f => ({ ...f, is_active: e.target.checked }))} />
              <span>Mailing Aktif</span>
            </label>
          </div>

          {/* Mail Gönderim — provider seçimli (Mandrill / Brevo) */}
          <div style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: `1px solid ${colors.borderLight}` }}>
            <h4 style={{ margin: '0 0 14px', fontSize: '12px', fontWeight: 600, color: colors.textSecondary }}>MAIL GÖNDERİM</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
              <div>
                <label style={s.label}>Gönderim Sağlayıcı</label>
                {superAdmin ? (
                  <select style={t.select} value={configForm.provider}
                    onChange={e => setConfigForm(f => ({ ...f, provider: e.target.value }))}>
                    <option value="mandrill">Mandrill (Mailchimp)</option>
                    <option value="brevo">Brevo (Sendinblue)</option>
                  </select>
                ) : (
                  <div style={{ ...s.input, background: colors.bgPage, color: colors.textSecondary, display: 'flex', alignItems: 'center' }}>
                    {configForm.provider === 'brevo' ? 'Brevo (Sendinblue)' : 'Mandrill (Mailchimp)'}
                  </div>
                )}
              </div>
              {configForm.provider === 'brevo' ? (
                <div>
                  <label style={s.label}>Brevo API Key</label>
                  <input style={s.input} type="password" value={configForm.brevo_api_key}
                    onChange={e => setConfigForm(f => ({ ...f, brevo_api_key: e.target.value }))}
                    placeholder="xkeysib-xxxxxxxxxxxx" />
                  <p style={{ fontSize: '11px', color: colors.textMuted, marginTop: '4px' }}>app.brevo.com → SMTP &amp; API → API Keys</p>
                </div>
              ) : (
                <div>
                  <label style={s.label}>Mandrill API Key</label>
                  <input style={s.input} type="password" value={configForm.mandrill_api_key}
                    onChange={e => setConfigForm(f => ({ ...f, mandrill_api_key: e.target.value }))}
                    placeholder="md-xxxxxxxxxxxxxxxxxxxx" />
                  <p style={{ fontSize: '11px', color: colors.textMuted, marginTop: '4px' }}>mandrillapp.com → Settings → API Keys</p>
                </div>
              )}
              <div>
                <label style={s.label}>Gönderici E-posta</label>
                <input style={s.input} value={configForm.from_email}
                  onChange={e => setConfigForm(f => ({ ...f, from_email: e.target.value }))}
                  placeholder="info@markaadi.com" />
              </div>
            </div>
            <div style={{ marginTop: '16px', maxWidth: 'min(100%, max(calc(33% - 8px), 240px))' }}>
              <label style={s.label}>Gönderici Adı</label>
              <input style={s.input} value={configForm.from_name}
                onChange={e => setConfigForm(f => ({ ...f, from_name: e.target.value }))}
                placeholder="Marka Adı" />
            </div>
            {configForm.provider === 'brevo' && (
              <p style={{ ...ui.notice, fontSize: '12px', marginTop: '12px', marginBottom: 0 }}>
                Brevo seçildi — gönderimler Brevo transactional API'siyle yapılır. Gönderici e-postanın Brevo'da <strong>doğrulanmış gönderici (verified sender)</strong> olması gerekir.
              </p>
            )}
          </div>

          {/* Mailchimp — yalnız Mandrill kullanan markalarda (süper admin her zaman görür) */}
          {mailchimpGorunur && (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ margin: '0 0 14px', fontSize: '12px', fontWeight: 600, color: colors.textSecondary }}> Mailchimp (Audience Yönetimi — Opsiyonel)</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <label style={s.label}>Marketing API Key</label>
                <input style={s.input} type="password" value={configForm.mailchimp_api_key}
                  onChange={e => setConfigForm(f => ({ ...f, mailchimp_api_key: e.target.value }))}
                  placeholder="xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-us9" />
              </div>
              <div>
                <label style={s.label}>Server Prefix</label>
                <input style={s.input} value={configForm.mailchimp_server}
                  onChange={e => setConfigForm(f => ({ ...f, mailchimp_server: e.target.value }))}
                  placeholder="us9" />
              </div>
              <div>
                <label style={s.label}>Audience ID</label>
                <input style={s.input} value={configForm.mailchimp_audience_id}
                  onChange={e => setConfigForm(f => ({ ...f, mailchimp_audience_id: e.target.value }))}
                  placeholder="065fed82a3" />
              </div>
              <div>
                <label style={s.label}>Store ID</label>
                <input style={s.input} value={configForm.mailchimp_store_id}
                  onChange={e => setConfigForm(f => ({ ...f, mailchimp_store_id: e.target.value }))}
                  placeholder={`seux-store-${selectedBrand.id}`} />
              </div>
            </div>
          </div>
          )}

          <div className="sx-wrap" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <button onClick={saveConfig} disabled={saving} style={{ ...t.btnPrimary, opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
            {mailchimpGorunur && config && configForm.mailchimp_api_key && (
              <button onClick={createStore} disabled={creatingStore} style={{ ...t.btnSecondary, opacity: creatingStore ? 0.7 : 1 }}>
                {creatingStore ? '' : ''} Mailchimp Store Oluştur
              </button>
            )}
          </div>

          {config && (
            <div style={{ ...t.cardFlat, marginTop: '16px', fontSize: '13px' }}>
              <div className="sx-break" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <span>Durum: <span style={ui.status(config.is_active)}><span style={ui.statusDot(config.is_active)} />{config.is_active ? 'Aktif' : 'Pasif'}</span></span>
                {config.from_email && <span>Gönderici: <strong>{config.from_email}</strong></span>}
                {config.mailchimp_store_id && <span>Store: <code style={{ background: colors.bgHover, padding: '2px 6px', borderRadius: radius.sm }}>{config.mailchimp_store_id}</code></span>}
                {config.updated_at && <span style={{ color: colors.textMuted }}>Güncellendi: {new Date(config.updated_at).toLocaleString('tr-TR')}</span>}
              </div>
            </div>
          )}
        </div>
        )
      })()}

      {tab === 'scenarios' && (
        <div>
          {!config?.is_active && (
            <div style={{ ...ui.notice, marginBottom: '16px' }}> Mailing henüz aktif değil. Ayarları yapıp aktif edin.
            </div>
          )}
          {scenarios.map(sc => (
            <ScenarioCard
              key={sc.scenario}
              sc={sc}
              onSave={saveScenario}
              onRun={() => runScenario(sc.scenario)}
              onResults={() => setAnketEkrani(true)}
              running={running[sc.scenario]}
              configActive={config?.is_active}
            />
          ))}
        </div>
      )}

      {tab === 'logs' && (
        <div style={s.card}>
          <h3 style={{ ...t.sectionTitle, margin: '0 0 16px' }}> Son Gönderimler</h3>
          {logs.length === 0 ? (
            <p style={ui.emptyText}>Henüz gönderim yapılmamış.</p>
          ) : (
            <div className="sx-scroll-x"><table style={t.table}>
              <thead>
                <tr style={{ background: colors.bgPage }}>
                  <th style={t.th}>Email</th>
                  <th style={t.th}>Senaryo</th>
                  <th style={t.th}>Durum</th>
                  <th style={t.th}>Tarih</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <tr key={log.id}>
                    <td style={t.td}>{log.email}</td>
                    <td style={t.td}>
                      <span style={ui.chip}>
                        {SCENARIO_LABELS[log.scenario]?.icon} {SCENARIO_LABELS[log.scenario]?.title || log.scenario}
                      </span>
                    </td>
                    <td style={t.td}>
                      <span style={ui.status(log.status === 'sent')}><span style={ui.statusDot(log.status === 'sent')} />{log.status}</span>
                    </td>
                    <td style={{ ...t.td, color: colors.textSecondary }}>
                      {new Date(log.created_at).toLocaleString('tr-TR')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table></div>
          )}
        </div>
      )}
    </div>
  )
}

function ScenarioCard({ sc, onSave, onRun, onResults, running, configActive }) {
  const info = SCENARIO_LABELS[sc.scenario] || {}
  const [form, setForm] = useState({ ...sc })
  const [expanded, setExpanded] = useState(false)

  function set(k, v) { setForm(f => ({ ...f, [k]: v })) }

  return (
    <div style={{ ...s.card }}>
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0, flex: '1 1 240px' }}>
          <span style={{ fontSize: '24px' }}>{info.icon}</span>
          <div>
            <div style={{ ...t.sectionTitle, margin: 0 }}>{info.title}</div>
            <div style={{ ...t.sectionSubtitle, marginTop: '2px' }}>{info.desc}</div>
          </div>
        </div>
        <div className="sx-wrap" style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={ui.status(form.is_active)}><span style={ui.statusDot(form.is_active)} />{form.is_active ? 'Aktif' : 'Pasif'}</span>
          {form.test_mode && <span style={ui.chip}>TEST</span>}
          {sc.scenario === 'purchase_survey' && (
            <button onClick={onResults} style={ui.btnQuiet}>Sonuçlar</button>
          )}
          <button onClick={() => setExpanded(e => !e)} style={ui.btnQuiet}>
            {expanded ? 'Kapat' : 'Düzenle'}
          </button>
          <button onClick={onRun} disabled={running || !configActive} style={{ ...ui.btnSm, opacity: (running || !configActive) ? 0.5 : 1 }}>
            {running ? ' Çalışıyor...' : ' Şimdi Çalıştır'}
          </button>
        </div>
      </div>

      {expanded && (
        <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: `1px solid ${colors.borderLight}` }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '16px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.is_active} onChange={e => set('is_active', e.target.checked)} />
              <span>Senaryo Aktif</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.test_mode} onChange={e => set('test_mode', e.target.checked)} />
              <span>Test Modu</span>
            </label>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '16px' }}>
            {sc.scenario === 'abandoned_cart' && (
              <div>
                <label style={s.label}>Kaç saat sonra tetiklensin?</label>
                <input type="number" style={s.input} value={form.hours_threshold}
                  onChange={e => set('hours_threshold', parseInt(e.target.value))} min="1" />
              </div>
            )}
            {sc.scenario === 'inactive_user' && (
              <div>
                <label style={s.label}>Kaç gün pasif sayılsın?</label>
                <input type="number" style={s.input} value={form.days_threshold}
                  onChange={e => set('days_threshold', parseInt(e.target.value))} min="1" />
              </div>
            )}
            {form.test_mode && (
              <div>
                <label style={s.label}>Test Email Adresi</label>
                <input style={s.input} value={form.test_email || ''}
                  onChange={e => set('test_email', e.target.value)}
                  placeholder="test@example.com" />
              </div>
            )}
          </div>

          <button onClick={() => onSave(form)} style={ui.btnPrimarySm}>Kaydet</button>
        </div>
      )}
    </div>
  )
}

function gunEkle(gun) {
  const d = new Date()
  d.setDate(d.getDate() + gun)
  return d.toISOString().slice(0, 10)
}

function AnketSonuclari({ brandId, markaAdi, headers, onBack }) {
  const [bas, setBas] = useState(gunEkle(-30))
  const [bit, setBit] = useState(gunEkle(0))
  const [yalnizYanit, setYalnizYanit] = useState(false)
  const [sayfa, setSayfa] = useState(1)
  const [istatistik, setIstatistik] = useState(null)
  const [liste, setListe] = useState(null)
  const [yukleniyor, setYukleniyor] = useState(true)
  const [hata, setHata] = useState('')
  const [indiriliyor, setIndiriliyor] = useState(false)
  const LIMIT = 25

  useEffect(() => { cek() }, [brandId, bas, bit, yalnizYanit, sayfa]) // eslint-disable-line

  async function cek() {
    setYukleniyor(true)
    setHata('')
    try {
      const q = `start=${bas}&end=${bit}`
      const [i, l] = await Promise.all([
        axios.get(`${API}/admin/brands/${brandId}/survey-stats?${q}`, { headers }),
        axios.get(`${API}/admin/brands/${brandId}/survey-results?${q}&page=${sayfa}&limit=${LIMIT}${yalnizYanit ? '&answered=1' : ''}`, { headers })
      ])
      setIstatistik(i.data)
      setListe(l.data)
    } catch (e) {
      setHata(e.response?.data?.error || e.message)
    }
    setYukleniyor(false)
  }

  async function csvIndir() {
    setIndiriliyor(true)
    try {
      const r = await axios.get(`${API}/admin/brands/${brandId}/survey-results/export?start=${bas}&end=${bit}`, { headers, responseType: 'blob' })
      const url = window.URL.createObjectURL(r.data)
      const a = document.createElement('a')
      a.href = url
      a.download = `anket-sonuclari-${bas}_${bit}.csv`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (e) {
      setHata('CSV indirilemedi: ' + (e.message || ''))
    }
    setIndiriliyor(false)
  }

  const g = istatistik?.genel
  const gonderilen = Number(g?.gonderilen || 0)
  const yanitlanan = Number(g?.yanitlanan || 0)
  const oran = gonderilen > 0 ? Math.round((yanitlanan / gonderilen) * 100) : 0
  const sorular = istatistik?.sorular || []
  const toplamSayfa = liste ? Math.max(1, Math.ceil(liste.toplam / LIMIT)) : 1

  return (
    <div>
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button onClick={onBack} style={ui.btnQuiet}>Geri</button>
          <h2 style={{ ...t.pageTitle, margin: 0 }}>Anket Sonuçları — {markaAdi}</h2>
        </div>
        <button onClick={csvIndir} disabled={indiriliyor} style={{ ...ui.btnSm, opacity: indiriliyor ? 0.5 : 1 }}>
          {indiriliyor ? 'Hazırlanıyor...' : 'CSV İndir'}
        </button>
      </div>

      {hata && <div style={{ ...ui.notice, marginBottom: '16px', color: colors.dangerText }}>{hata}</div>}

      <div style={{ ...s.card, display: 'flex', gap: '16px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div>
          <label style={s.label}>Başlangıç</label>
          <input type="date" style={s.input} value={bas} onChange={e => { setBas(e.target.value); setSayfa(1) }} />
        </div>
        <div>
          <label style={s.label}>Bitiş</label>
          <input type="date" style={s.input} value={bit} onChange={e => { setBit(e.target.value); setSayfa(1) }} />
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer', paddingBottom: '8px' }}>
          <input type="checkbox" checked={yalnizYanit} onChange={e => { setYalnizYanit(e.target.checked); setSayfa(1) }} />
          <span>Yalnız anketi dolduranlar</span>
        </label>
        <div style={{ ...t.sectionSubtitle, paddingBottom: '10px' }}>Tarih aralığı, anketin GÖNDERİLDİĞİ güne göre süzer.</div>
      </div>

      {yukleniyor && <p style={ui.emptyText}>Yükleniyor...</p>}

      {!yukleniyor && istatistik && (
        <>
          <div className="sx-grid-stat" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '20px' }}>
            {[
              { label: 'Anket Gönderilen', val: gonderilen },
              { label: 'Anketi Dolduran', val: yanitlanan },
              { label: 'Yanıt Oranı', val: oran + '%' },
              { label: 'Mail Gitmeyen', val: Number(g?.mail_basarisiz || 0) }
            ].map((x, i) => (
              <div key={i} style={ui.statBox}>
                <div style={ui.statLabel}>{x.label}</div>
                <div style={ui.statValue}>{x.val}</div>
              </div>
            ))}
          </div>

          <div style={s.card}>
            <h3 style={{ ...t.sectionTitle, margin: '0 0 16px' }}>Soru Ortalamaları</h3>
            {sorular.length === 0 ? <p style={ui.emptyText}>Bu marka için tanımlı soru yok.</p> : (
              <div className="sx-scroll-x"><table style={t.table}>
                <thead>
                  <tr style={{ background: colors.bgPage }}>
                    <th style={t.th}>Soru</th>
                    <th style={t.th}>Ortalama</th>
                    <th style={t.th}>Puanlayan</th>
                    <th style={t.th}>Yorum</th>
                  </tr>
                </thead>
                <tbody>
                  {sorular.map(q => (
                    <tr key={q.id}>
                      <td style={{ ...t.td, fontWeight: 600 }}>{q.label}</td>
                      <td style={{ ...t.td, ...ui.numMuted }}>
                        {q.ortalama ? q.ortalama + ' / ' + q.max_rating : '-'}
                      </td>
                      <td style={{ ...t.td, ...ui.numMuted }}>{q.puan_sayisi}</td>
                      <td style={{ ...t.td, ...ui.numMuted }}>{q.has_comment ? q.yorum_sayisi : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table></div>
            )}
          </div>

          <div style={s.card}>
            <h3 style={{ ...t.sectionTitle, margin: '0 0 16px' }}>
              Kayıtlar {liste ? '(' + liste.toplam + ')' : ''}
            </h3>
            {!liste || liste.kayitlar.length === 0 ? (
              <p style={ui.emptyText}>Bu aralıkta kayıt yok.</p>
            ) : (
              <>
                <div className="sx-scroll-x"><table style={t.table}>
                  <thead>
                    <tr style={{ background: colors.bgPage }}>
                      <th style={t.th}>Sipariş</th>
                      <th style={t.th}>Müşteri</th>
                      <th style={t.th}>E-posta</th>
                      <th style={t.th}>Gönderim</th>
                      <th style={t.th}>Yanıt</th>
                      {sorular.map(q => <th key={q.id} style={t.th} title={q.label}>{q.order_index}. soru</th>)}
                      <th style={t.th}>Yorumlar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {liste.kayitlar.map(k => {
                      const harita = {}
                      ;(k.cevaplar || []).forEach(c => { harita[c.question_id] = c })
                      const yorumlar = (k.cevaplar || []).filter(c => c.comment && String(c.comment).trim())
                      return (
                        <tr key={k.id}>
                          <td style={{ ...t.td, ...ui.numMuted, whiteSpace: 'nowrap' }}>{k.order_code}</td>
                          <td style={{ ...t.td, fontWeight: 600 }}>{k.customer_name || '-'}</td>
                          <td style={t.td}>{k.email}</td>
                          <td style={{ ...t.td, fontSize: '12px', whiteSpace: 'nowrap' }}>
                            {k.created_at ? new Date(k.created_at).toLocaleString('tr-TR') : '-'}
                            {k.mail_sent === false && <span title={k.mail_error || ''} style={{ color: colors.dangerText, marginLeft: '6px' }}>gitmedi</span>}
                          </td>
                          <td style={{ ...t.td, fontSize: '12px', whiteSpace: 'nowrap', color: k.used_at ? colors.textSecondary : colors.textMuted }}>
                            {k.used_at ? new Date(k.used_at).toLocaleString('tr-TR') : 'doldurmadı'}
                          </td>
                          {sorular.map(q => {
                            const c = harita[q.id]
                            return (
                              <td key={q.id} style={{ ...t.td, ...ui.numMuted }}>
                                {c && c.rating !== null && c.rating !== undefined ? c.rating : '-'}
                              </td>
                            )
                          })}
                          <td style={{ ...t.td, maxWidth: '260px', fontSize: '12px', color: colors.textSecondary }}>
                            {yorumlar.length === 0 ? '-' : yorumlar.map((c, i) => <div key={i}>{c.comment}</div>)}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table></div>

                {toplamSayfa > 1 && (
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '16px' }}>
                    <button onClick={() => setSayfa(p => Math.max(1, p - 1))} disabled={sayfa <= 1}
                      style={{ ...ui.btnQuiet, opacity: sayfa <= 1 ? 0.4 : 1 }}>Önceki</button>
                    <span style={{ fontSize: '13px', color: colors.textSecondary }}>{sayfa} / {toplamSayfa}</span>
                    <button onClick={() => setSayfa(p => Math.min(toplamSayfa, p + 1))} disabled={sayfa >= toplamSayfa}
                      style={{ ...ui.btnQuiet, opacity: sayfa >= toplamSayfa ? 0.4 : 1 }}>Sonraki</button>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default SmartMailing